import * as yup from 'yup';
import _ from 'lodash';
import { BerthBuoyConf } from './common/BerthBuoy.conf';
import { PilotiINConf } from './common/PilotIN.conf';
import { PilotiOUTConf } from './common/PilotOUT.conf';
import { BunkerConf } from './common/Bunker.conf';
import { countries } from '../../../components/form/components/CountryAutocomplete.component';

const customFields = (fields) =>
  fields.map((field) => ({
    ...field,
    disabled: true,
    type: 'text',
  }));

const CommonConf = {
  schema: {
    email: yup
      .string()
      .nullable()
      .email('Please enter a valid email')
      .required('Email is required'),
  },
  defaultValues: {
    email: '',
  },
  fields: [
    { id: 'id_yacht', name: 'id_yacht', type: 'text', label: 'Yacht', disabled: true, xs: 12, sm: 6 },
    { id: 'email', name: 'email', type: 'text', label: 'Email', required: true, xs: 12, sm: 6 },
  ],
};

const dateField = { id: 'requested_date', name: 'requested_date', type: 'text', label: 'Date', disabled: true, xs: 12, sm: 6 };
const locationField = { id: 'id_marina', name: 'id_marina', type: 'text', label: 'Location', disabled: true, xs: 12, sm: 6 };
const yachtFields = [
  { id: 'yacht_type', name: 'yacht_type', type: 'text', label: 'Yacht Type', disabled: true, xs: 12, sm: 3 },
  { id: 'loa', name: 'loa', type: 'text', label: 'LOA', disabled: true, xs: 12, sm: 3 },
  { id: 'beam', name: 'beam', type: 'text', label: 'Beam', disabled: true, xs: 12, sm: 3 },
  { id: 'draft', name: 'draft', type: 'text', label: 'Draft', disabled: true, xs: 12, sm: 3 },
];
const paymentTypeField = { id: 'payment_type', name: 'payment_type', type: 'text', label: 'Payment', disabled: true, xs: 12, sm: 6 };
const checkOutDateField = { id: 'check_out_date', name: 'check_out_date', type: 'text', label: 'Check out date', disabled: true, xs: 12, sm: 6 };

export const tpNazionalitaOptions = [
  { id: 'I', label: 'Italia' },
  { id: 'C', label: 'UE' },
  { id: 'E', label: 'Estero (no UE)' },
  { id: 'R', label: 'RSM' },
  { id: 'V', label: 'Vaticano' },
];

export const codPaeseOptions = countries
  .map(({ code, label }) => ({
    id: code,
    label:
      (new Intl.DisplayNames(['it'], { type: 'region' }).of(code) || label).toUpperCase(),
  }))
  .sort((a, b) => a.label.localeCompare(b.label, 'it'));

const billingCommonFields = [
  {
    id: 'mexal_tp_nazionalita',
    name: 'mexal_tp_nazionalita',
    type: 'select-custom',
    label: 'Nationality',
    options: tpNazionalitaOptions,
    xs: 12,
    sm: 6,
  },
  {
    id: 'mexal_cod_paese',
    name: 'mexal_cod_paese',
    type: 'select-custom',
    label: 'Country',
    options: codPaeseOptions,
    xs: 12,
    sm: 6,
  },
  { id: 'mexal_indirizzo', name: 'mexal_indirizzo', type: 'text', label: 'Address', xs: 12, sm: 6 },
  { id: 'mexal_cap', name: 'mexal_cap', type: 'text', label: 'ZIP Code', xs: 12, sm: 6 },
  { id: 'mexal_localita', name: 'mexal_localita', type: 'text', label: 'City', xs: 12, sm: 6 },
  { id: 'mexal_provincia', name: 'mexal_provincia', type: 'text', label: 'Province', xs: 12, sm: 6 },
];

const billingHeader = [
  { id: 'billing_divider', type: 'divider', label: 'Billing details', xs: 12, sm: 12 },
  { id: 'invoice_entity', name: 'invoice_entity', type: 'text', label: 'Invoice Entity', disabled: true, xs: 12, sm: 6 },
  { id: 'mexal_codice', name: 'mexal_codice', type: 'text', label: 'Mexal Code', xs: 12, sm: 6 },
];

const companyBillingFields = [
  ...billingHeader,
  { id: 'mexal_ragione_sociale', name: 'mexal_ragione_sociale', type: 'text', label: 'Company Name', xs: 12, sm: 6 },
  { id: 'mexal_partita_iva', name: 'mexal_partita_iva', type: 'text', label: 'VAT Number', xs: 12, sm: 6 },
  { id: 'mexal_pec', name: 'mexal_pec', type: 'text', label: 'PEC', xs: 12, sm: 6 },
  { id: 'mexal_codice_sdi', name: 'mexal_codice_sdi', type: 'text', label: 'SDI Code', xs: 12, sm: 6 },
  ...billingCommonFields,
];

const naturalPersonBillingFields = [
  ...billingHeader,
  { id: 'mexal_nome', name: 'mexal_nome', type: 'text', label: 'First Name', xs: 12, sm: 6 },
  { id: 'mexal_cognome', name: 'mexal_cognome', type: 'text', label: 'Last Name', xs: 12, sm: 6 },
  { id: 'mexal_codice_fiscale', name: 'mexal_codice_fiscale', type: 'text', label: 'Tax Code', xs: 12, sm: 6 },
  ...billingCommonFields,
];

const soleTraderBillingFields = [
  ...billingHeader,
  { id: 'mexal_nome', name: 'mexal_nome', type: 'text', label: 'First Name', xs: 12, sm: 6 },
  { id: 'mexal_cognome', name: 'mexal_cognome', type: 'text', label: 'Last Name', xs: 12, sm: 6 },
  { id: 'mexal_codice_fiscale', name: 'mexal_codice_fiscale', type: 'text', label: 'Tax Code', xs: 12, sm: 6 },
  { id: 'mexal_partita_iva', name: 'mexal_partita_iva', type: 'text', label: 'VAT Number', xs: 12, sm: 6 },
  { id: 'mexal_ragione_sociale', name: 'mexal_ragione_sociale', type: 'text', label: 'Company Name', xs: 12, sm: 6 },
  { id: 'mexal_denominazione', name: 'mexal_denominazione', type: 'text', label: 'Business Name', xs: 12, sm: 6 },
  { id: 'mexal_pec', name: 'mexal_pec', type: 'text', label: 'PEC', xs: 12, sm: 6 },
  { id: 'mexal_codice_sdi', name: 'mexal_codice_sdi', type: 'text', label: 'SDI Code', xs: 12, sm: 6 },
  ...billingCommonFields,
];

const defaultBillingFields = [
  ...billingHeader,
  ...billingCommonFields,
];

const getBillingFields = (entityType) => {
  if (entityType === 'NATURAL PERSON') return naturalPersonBillingFields;
  if (entityType === 'COMPANY') return companyBillingFields;
  if (entityType === 'SOLE TRADER') return soleTraderBillingFields;
  return defaultBillingFields;
};

export const SendEmailFormConf = (() => {
  const invoicingDefaultValues = {
    invoice_entity: '',
    mexal_codice: '',
    mexal_ragione_sociale: '',
    mexal_nome: '',
    mexal_cognome: '',
    mexal_indirizzo: '',
    mexal_cap: '',
    mexal_localita: '',
    mexal_provincia: '',
    mexal_tp_nazionalita: '',
    mexal_partita_iva: '',
    mexal_codice_fiscale: '',
    mexal_cod_paese: '',
    mexal_pec: '',
    mexal_denominazione: '',
    mexal_codice_sdi: '',
  };

  const makeConf = (baseFields) => ({
    schema: yup.object({ ...CommonConf.schema }),
    defaultValues: { ...CommonConf.defaultValues, ...invoicingDefaultValues },
    fields: _.concat(baseFields, companyBillingFields),
    getFields: (entityType) => _.concat(baseFields, getBillingFields(entityType)),
  });

  const berthInlineYachtFields = [
    { id: 'yacht_type', name: 'yacht_type', type: 'text', label: 'Yacht Type', disabled: true, xs: 12, sm: 3 },
    { id: 'loa', name: 'loa', type: 'text', label: 'LOA', disabled: true, xs: 12, sm: 3 },
    { id: 'beam', name: 'beam', type: 'text', label: 'Beam', disabled: true, xs: 12, sm: 3 },
    { id: 'draft', name: 'draft', type: 'text', label: 'Draft', disabled: true, xs: 12, sm: 3 },
  ];

  const berthBuoyConf = makeConf(_.concat(
    { id: 'id', name: 'id', type: 'text', label: 'ID', disabled: true, xs: 12, sm: 6 },
    { id: 'custom_request', name: 'custom_request', type: 'text', label: 'Custom Request', xs: 12, sm: 6 },
    { id: 'email', name: 'email', type: 'text', label: 'Email', required: true, xs: 12, sm: 6 },
    { id: 'id_yacht', name: 'id_yacht', type: 'text', label: 'Yacht', disabled: true, xs: 12, sm: 6 },
    berthInlineYachtFields,
    locationField,
    customFields(BerthBuoyConf.fields.slice(1, 4)),
    { id: 'tender', name: 'tender', type: 'switch', label: 'Tender', disabled: true, xs: 12, sm: 6 },
    { ...BerthBuoyConf.fields[7], disabled: true, xs: 12, sm: 6 },
    paymentTypeField,
    { id: 'note', name: 'note', type: 'text_multiline', label: 'Note', xs: 12, sm: 12, minHeight: 120 },
  ));


  const pilotInConf = makeConf(_.concat(
    [
      { id: 'id', name: 'id', type: 'text', label: 'ID', disabled: true, xs: 12, sm: 6 },
      { id: 'email', name: 'email', type: 'text', label: 'Email', required: true, xs: 12, sm: 6 },
      { id: 'id_yacht', name: 'id_yacht', type: 'text', label: 'Yacht', disabled: true, xs: 12, sm: 6 },
      { id: 'port', name: 'port', type: 'text', label: 'Port', disabled: true, xs: 12, sm: 6 },
    ],
    yachtFields,
    { id: 'gross_tonn', name: 'gross_tonn', type: 'text', label: 'Gross Tonnage', disabled: true, xs: 12, sm: 6 },
    { id: 'payment_type', name: 'payment_type', type: 'text', label: 'Payment', disabled: true, xs: 12, sm: 6 },
    customFields(PilotiINConf.fields.slice(1, 3)),
    { id: 'note', name: 'note', type: 'text_multiline', label: 'Note', xs: 12, sm: 12, minHeight: 120 },
  ));

  const pilotOutConf = makeConf(_.concat(
    [
      { id: 'id', name: 'id', type: 'text', label: 'ID', disabled: true, xs: 12, sm: 6 },
      { id: 'email', name: 'email', type: 'text', label: 'Email', required: true, xs: 12, sm: 6 },
      { id: 'id_yacht', name: 'id_yacht', type: 'text', label: 'Yacht', disabled: true, xs: 12, sm: 6 },
      { id: 'port', name: 'port', type: 'text', label: 'Port', disabled: true, xs: 12, sm: 6 },
    ],
    yachtFields,
    { id: 'gross_tonn', name: 'gross_tonn', type: 'text', label: 'Gross Tonnage', disabled: true, xs: 12, sm: 6 },
    { id: 'payment_type', name: 'payment_type', type: 'text', label: 'Payment', disabled: true, xs: 12, sm: 6 },
    checkOutDateField,
    customFields(PilotiOUTConf.fields.slice(1, 2)),
    { id: 'note', name: 'note', type: 'text_multiline', label: 'Note', xs: 12, sm: 12, minHeight: 120 },
  ));

  return {
    'BERTH RESERVATION': berthBuoyConf,
    'BUOY RESERVATION': berthBuoyConf,
    'PILOTS IN': pilotInConf,
    'PILOTS OUT': pilotOutConf,

    'GARBAGE DISPOSAL': makeConf(_.concat(
      [
        { id: 'id', name: 'id', type: 'text', label: 'ID', disabled: true, xs: 12, sm: 6 },
        { id: 'email', name: 'email', type: 'text', label: 'Email', required: true, xs: 12, sm: 6 },
        { id: 'id_yacht', name: 'id_yacht', type: 'text', label: 'Yacht', disabled: true, xs: 12, sm: 6 },
      ],
      [dateField, locationField],
      [
        { id: 'service_time', name: 'service_time', type: 'text', label: 'Time', disabled: true, xs: 12, sm: 6 },
        { id: 'garbage_quantity', name: 'garbage_quantity', type: 'text', label: 'Garbage quantity', disabled: true, xs: 12, sm: 6 },
        paymentTypeField,
        { id: 'note', name: 'note', type: 'text_multiline', label: 'Note', xs: 12, sm: 12, minHeight: 120 },
      ]
    )),

    BUNKER: makeConf(_.concat(
      [
        { id: 'id', name: 'id', type: 'text', label: 'ID', disabled: true, xs: 12, sm: 6 },
        { id: 'email', name: 'email', type: 'text', label: 'Email', required: true, xs: 12, sm: 6 },
        { id: 'id_yacht', name: 'id_yacht', type: 'text', label: 'Yacht', disabled: true, xs: 12, sm: 6 },
      ],
      dateField,
      customFields(BunkerConf.fields.slice(0, 5)).filter((field) => field.id !== 'service_place'),
      { id: 'selling_price', name: 'selling_price', type: 'text', label: 'Selling Price', disabled: true, xs: 12, sm: 6 },
      { id: 'purchase_price', name: 'purchase_price', type: 'text', label: 'Purchase Price', disabled: true, xs: 12, sm: 6 },
      { id: 'note', name: 'note', type: 'text_multiline', label: 'Note', xs: 12, sm: 12, minHeight: 120 },
    )),
  };
})();
